module.exports = __webpack_public_path__ + "static/media/ark-io-logo.cb1423b6.png";